var _g, _path, _path2, _g2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 552,
    viewBox: "0 0 569 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_7652)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdii_1931_7652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 107C58 69.9969 87.9969 40 125 40H449C486.003 40 516 69.9969 516 107V431C516 468.003 486.003 498 449 498H125C87.9969 498 58 468.003 58 431V107Z",
    fill: "url(#paint0_linear_1931_7652)",
    fillOpacity: 0.17
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.445 181.326C306.696 177.38 306.304 173.308 306.304 169.145C306.304 133.166 335.568 104 371.665 104C407.763 104 437.026 133.166 437.026 169.145C437.026 205.123 407.763 234.289 371.665 234.289C351.979 234.289 334.324 225.614 322.342 211.89L234.433 253.884C234.269 259.933 233.058 265.722 230.974 271.077L336.91 339.381C340.717 336.241 345.016 333.57 349.76 331.492C377.336 319.416 409.48 331.98 421.557 359.556C433.633 387.132 421.069 419.276 393.493 431.353C365.917 443.429 333.773 430.864 321.696 403.289C316.651 391.769 315.907 379.452 318.76 368.133L208.58 297.093C200.974 301.472 192.144 303.978 182.726 303.978C154.159 303.978 131 280.917 131 252.469C131 224.021 154.159 200.959 182.726 200.959C199.507 200.959 214.421 208.916 223.872 221.249L307.445 181.326Z",
    fill: "url(#paint1_linear_1931_7652)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1931_7652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: -8,
    width: 491,
    height: 299
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.1 131.761C142.599 121.474 192.418 37.6586 217.639 -2.96343C327.125 18.2007 464.807 -12.5365 483.405 -6.75076C506.652 0.481412 617.151 129.867 601.181 241.653C585.212 353.439 536.845 237.304 517.511 232.095C498.176 226.886 475.445 253.709 397.429 177.843C319.413 101.978 368.404 143.86 204.073 201.333C39.7427 258.806 148.225 144.619 145.1 131.761Z",
    fill: "#18D5FF",
    fillOpacity: 0.74
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1931_7652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 107C58 69.9969 87.9969 40 125 40H449C486.003 40 516 69.9969 516 107V431C516 468.003 486.003 498 449 498H125C87.9969 498 58 468.003 58 431V107Z",
    fill: "url(#paint2_linear_1931_7652)",
    fillOpacity: 0.17
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1931_7652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 40,
    width: 458,
    height: 458
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 107C58 69.9969 87.9969 40 125 40H449C486.003 40 516 69.9969 516 107V431C516 468.003 486.003 498 449 498H125C87.9969 498 58 468.003 58 431V107Z",
    fill: "url(#paint3_linear_1931_7652)",
    fillOpacity: 0.17
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1931_7652)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter1_f_1931_7652)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.211 581.812C429.85 596.028 329.297 680.832 279.191 721.457C149 646.078 -40.0754 624.385 -61.2214 608.789C-87.6539 589.293 -171.291 375.529 -101.516 240.11C-31.7412 104.69 -21.4371 274.096 0.902928 289.283C23.243 304.47 64.0741 280.332 129.971 411.52C195.868 542.707 151.941 467.666 386.802 467.064C621.663 466.461 432.912 564.041 431.211 581.812Z",
    fill: "#C650EE"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdii_1931_7652",
    x: 9.7,
    y: 9.8,
    width: 536.5,
    height: 541.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1931_7652"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -17,
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.65
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.0941176 0 0 0 0 1 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1931_7652",
    result: "effect2_dropShadow_1931_7652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1931_7652",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1931_7652"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.596078 0 0 0 0 0.501961 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1931_7652",
    result: "effect4_innerShadow_1931_7652"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1931_7652",
    x: -429.668,
    y: -113.027,
    width: 1235.21,
    height: 1135.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150.5,
    result: "effect1_foregroundBlur_1931_7652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1931_7652",
    x1: 58,
    y1: 458.5,
    x2: 467.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4318FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BE7ED",
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1931_7652",
    x1: 375.613,
    y1: -57.2639,
    x2: 76.7079,
    y2: 533.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139656,
    stopColor: "#3BE7ED",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4318FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743315,
    stopColor: "#C650EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1931_7652",
    x1: 58,
    y1: 458.5,
    x2: 467.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4318FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BE7ED",
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1931_7652",
    x1: 58,
    y1: 458.5,
    x2: 467.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4318FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BE7ED",
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_7652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 569,
    height: 552,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.141ce1e0d4a6ae54977e00ca90ff7147.svg";
export { ForwardRef as ReactComponent };